import React, { useState, useRef, useEffect } from "react"
import * as styles from "./fiddle.module.css"

const fiddleHost = "https://fiddle.fastly.dev"

export default (props) => {
  const [embedID] = useState(String(Math.trunc(Math.random() * 1000)))
  const elContainer = useRef(null)

  useEffect(() => {
    const handleMessage = (evt) => {
      if (
        !props.heightIsStatic &&
        evt.data.embedID === embedID &&
        evt.data.event === "resize" &&
        evt.data.contentHeight > elContainer.current.offsetHeight
      ) {
        elContainer.current.style.height = evt.data.contentHeight + "px"
      }
    }
    window.addEventListener("message", handleMessage)
    return () => window.removeEventListener("message", handleMessage)
  }, [embedID, props.heightIsStatic])

  const query = new URLSearchParams()
  query.set("embedID", embedID)
  if (props.defaultSub) query.set("defaultSub", props.defaultSub)
  if (props.border !== undefined) query.set("border", props.border)

  return (
    <div className={styles.fiddle}>
      <iframe
        role="presentation"
        title="Fiddle"
        loading="lazy"
        ref={elContainer}
        src={fiddleHost + "/fiddle/" + props.id + "/embedded?" + query.toString()}
      />
    </div>
  )
}
